import * as serviceWorker from "./serviceWorker";
import { Provider } from 'react-redux';
import { store } from 'store/configureStore';
import { applicationId } from './settings.json';
import "./index.scss";


import React from "react";
import ReactDOM from "react-dom";
import configService from "./services/ConfigService";
import App from "./App";

const getEntryNode = async () => {
  const APP_ROOT_ID = "gs-app";
  return document.getElementById(APP_ROOT_ID) ||  document.getElementById("root");
};

const attemptRender = async (count) => {
  try {
    const entryNode = await getEntryNode();
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      entryNode
    );
  } catch (error) {
    console.log("Unable to locate entry node: ", error);
    if (count < 5) setTimeout(attemptRender, 1000, count+1);
  }
};

const renderFunction = attemptRender(0)


serviceWorker.unregister();
